import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Container } from '../../ui/Container';
const items = [{
  title: 'Donate For Children',
  cta: 'Donate',
  to: '/en/partnership/donate-for-children'
}, {
  title: 'Scholarships Program',
  cta: 'Explore',
  to: '/en/partnership/scholarships'
}, {
  title: 'Institutional Partners',
  cta: 'Request A Brief',
  to: '/en/partnership/institutional-partners'
}];
export function Partnering() {
  return <section className="relative py-20 md:py-28 overflow-hidden bg-[#F7EDE9]/60" data-id="element-661" data-mp="1gog4qc1kgc8u">
      <Container data-id="element-662" data-mp="1gqk7urrn5782">
        <div className="text-center max-w-3xl mx-auto" data-id="element-663" data-mp="1ln15cckqcxxt">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-sage-100 text-forest-700 text-[11px] font-semibold tracking-[0.14em] uppercase" data-id="element-664" data-mp="1lmhlgqbirzh5">
            Our Support
          </span>
          <h2 className="font-display text-3xl md:text-5xl text-ink-900 leading-tight mt-5" data-id="element-665" data-mp="1ulwdhu7c4i3r">
            Partnering For Long-Term Impact
          </h2>
          <p className="mt-4 text-ink-700" data-id="element-666" data-mp="11519o3po5g6g">
            We collaborate with foundations, institutions, and community
            partners committed to strengthening Muslim families living as
            minorities.
          </p>
          <p className="mt-3 text-ink-500 text-sm" data-id="element-667" data-mp="r8o8ylvpi227">
            Together, we build sustainable structures that support future
            generations.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-7 md:gap-9" data-id="element-668" data-mp="1jwtuhaul3v33">
          {items.map((item, i) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          delay: i * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} whileHover={{
          y: -4
        }} className="group flex flex-col" data-id="element-669" data-mp="1f3r7xmo85lwe" data-mpi={i}>
              <Link to={item.to} className="relative flex flex-col rounded-3xl border-2 border-sand-300/80 bg-sage-100 px-7 py-8 shadow-soft ring-1 ring-inset ring-white/40 transition-all duration-300 hover:border-sand-400 hover:shadow-card" data-id="element-670" data-mp="3nal0xz8f3wsa">
                <h3 className="font-display text-xl md:text-2xl text-ink-900 leading-snug" data-id="element-671" data-mp="3ievyno50k1sa">
                  {item.title}
                </h3>
                <span className="mt-5 inline-flex w-fit items-center gap-1.5 rounded-full bg-sand-300 px-6 py-2.5 text-sm font-semibold text-ink-900 transition-colors duration-300 group-hover:bg-sand-400" data-id="element-672" data-mp="39cmqv614qmil">
                  {item.cta}
                  <ArrowRightIcon size={16} strokeWidth={2} className="transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-673" data-mp="17k8aibe8hq4a" />
                </span>
              </Link>
            </motion.div>)}
        </div>
      </Container>
    </section>;
}